<template>
  <v-overlay
    :model-value="isLoading"
    persistent
    class="align-center justify-center"
  >
    <v-progress-circular color="white" indeterminate size="64" />
  </v-overlay>
</template>

<script setup lang="ts">
type Props = {
  isLoading: boolean;
};

defineProps<Props>();
</script>
